// src/utils/detectCareerMismatch.js

const FIELDS = {
  "IT / Software": [
    "software","developer","engineer","programming","coding","react","node","python",
    "java","javascript","typescript","aws","cloud","devops","kubernetes","docker",
    "api","backend","frontend","fullstack","database","sql","nosql","git","agile",
    "scrum","machine learning","ai","data science","cybersecurity","network","linux",
    "microservices","ci/cd","sre","tech lead","product manager","qa","testing",
  ],
  "Healthcare / Medical": [
    "nurse","physician","doctor","medical","clinical","patient","hospital","pharmacy",
    "health","diagnosis","treatment","surgery","therapy","radiology","icu","ehr",
    "healthcare","dental","nursing","medication","drug","vaccine","lab","specimen",
    "hipaa","medical coding","icd","cpt","billing","rn","md","pa","np",
  ],
  "Finance / Banking": [
    "finance","accounting","audit","tax","cpa","financial analyst","investment",
    "banking","portfolio","equity","hedge","trading","risk","compliance","gaap",
    "ifrs","balance sheet","p&l","revenue","budget","forecasting","actuarial",
    "insurance","loan","mortgage","underwriting","credit",
  ],
  "Mechanical Engineering": [
    "mechanical","manufacturing","cad","solidworks","autocad","machining","cnc",
    "hvac","thermodynamics","fluid dynamics","stress analysis","tolerances",
    "gd&t","welding","fabrication","automation","robotics","plc","industrial",
    "quality control","iso","lean","six sigma","plant","maintenance engineer",
  ],
  "Marketing / Sales": [
    "marketing","seo","ppc","social media","content","branding","campaign",
    "sales","crm","salesforce","lead generation","conversion","funnel","growth",
    "email marketing","copywriting","pr","advertising","media buy",
    "market research","b2b","b2c","account executive","business development",
  ],
  "Legal": [
    "attorney","lawyer","paralegal","litigation","contract","legal","counsel",
    "compliance","regulatory","intellectual property","patent","trademark","law",
    "court","deposition","discovery","arbitration","employment law","corporate law",
  ],
  "Education": [
    "teacher","professor","curriculum","pedagogy","classroom","school","university",
    "student","instruction","tutoring","lesson plan","k-12","higher education",
    "academic","learning","assessment","grading","syllabus",
  ],
};

function detectField(text) {
  const lower = text.toLowerCase();
  let best = null, bestScore = 0;
  for (const [field, keywords] of Object.entries(FIELDS)) {
    const score = keywords.filter(k => lower.includes(k)).length;
    if (score > bestScore) { bestScore = score; best = field; }
  }
  return bestScore >= 2 ? best : null;
}

/**
 * Returns null if no mismatch, or { resumeField, jdField } if mismatch detected.
 */
export function detectCareerMismatch(resumeText, jdText) {
  const resumeField = detectField(resumeText);
  const jdField     = detectField(jdText);
  if (!resumeField || !jdField) return null;
  if (resumeField === jdField) return null;
  return { resumeField, jdField };
}